import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditWorker, WorkerList, WorkersOverview } from "../../components/worker";
import { PageHeader } from "../../components/v3";
import { CREATE_WORKER, VIEW_WORKER_ANALYTICS } from "../../constants";
import { useHasPermission } from "../../utils";

export const Workers = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasWorkerCreate = useHasPermission(CREATE_WORKER);
  const hasViewAnalytics = useHasPermission(VIEW_WORKER_ANALYTICS);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasWorkerCreate && {
      buttonText: "Add Worker",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          // title
          title="Workers"
          subtitle={`${totalCount} Workers`}
          // button
          buttons={buttons}
        />

        {/* card section */}
        {hasViewAnalytics ? (
          <>
            <Box sx={{ position: "relative", height: 40 }}>
              <WorkersOverview />
            </Box>
            <WorkerList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </>
        ) : (
          <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
            <WorkerList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </Box>
        )}

        {/* table section */}
      </PageLayout>

      {/* add worker modal */}
      <AddEditWorker open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
